export default __webpack_public_path__ + "static/media/pincodeicon.b4b28bf3.svg";